'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressInput = undefined;

var _AddressInput2 = require('./AddressInput');

var _AddressInput3 = _interopRequireDefault(_AddressInput2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AddressInput = _AddressInput3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/AddressInput/index.js
// module id = 1597
// module chunks = 0